import {Order, Package, Plan} from 'grpc-bob/subscription_pb';
import {StudentProfile} from 'grpc-bob/student_pb';
import {PROMOTION_STATUS} from '../../constants/enum';
import {AppState} from './reducer';

export const SET_LOADING = 'SET_LOADING';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_PLAN_ID = 'SET_PLAN_ID';
export const SET_PLANS = 'SET_PLANS';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_USER = 'SET_USER';
export const SET_CHOSEN_PACKAGE = 'SET_CHOSEN_PACKAGE';
export const SET_SUMMARY = 'SET_SUMMARY';
export const SET_ACTIVE_ORDER = 'SET_ACTIVE_ORDER';
export const SET_ORDERS = 'SET_ORDERS';
export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const SET_PROMOTION = 'SET_PROMOTION';
export const SET_PROMOTION_EFFECT = 'SET_PROMOTION_EFFECT';
export const SET_PARTIAL_STATE = 'SET_PARTIAL_STATE';
export const SET_PAYMENT_ORDER_ID = 'SET_PAYMENT_ORDER_ID';
// export const SET_PAYMENT_URL = 'SET_PAYMENT_URL';
export const SET_ORDER_WAITING_PAYMENT = 'SET_ORDER_WAITING_PAYMENT';

export type SetLoadingAction = {
  type: typeof SET_LOADING,
  payload: boolean
}

export type SetTokenAction = {
  type: typeof SET_TOKEN,
  payload: string
}

export type SetPlanIdAction = {
  type: typeof SET_PLAN_ID,
  payload: string
}

export type SetPlansAction = {
  type: typeof SET_PLANS,
  payload: Plan.AsObject[]
}

export type SetPackagesAction = {
  type: typeof SET_PACKAGES,
  payload: PackageWithPromotion[]
}

export type SetMessageAction = {
  type: typeof SET_MESSAGE,
  payload: string
}

export type SetUserAction = {
  type: typeof SET_USER,
  payload: StudentProfile.AsObject
}

export type SetChosenPackageAction = {
  type: typeof SET_CHOSEN_PACKAGE,
  payload: PackageWithPromotion | null
}

export type SetSummaryAction = {
  type: typeof SET_SUMMARY,
  payload: { order: Order.AsObject, user: StudentProfile.AsObject }
}

export type SetActiveOrderAction = {
  type: typeof SET_ACTIVE_ORDER,
  payload: Order.AsObject
}

export type SetOrdersAction = {
  type: typeof SET_ORDERS,
  payload: Order.AsObject[]
}

export type InitialPayload = {
  orders: Order.AsObject[],
  token: string,
  plans: Plan.AsObject[],
  user: StudentProfile.AsObject
}

export type SetInitialDataAction = {
  type: typeof SET_INITIAL_DATA,
  payload: InitialPayload
}

export interface IPromotion {
  text: string,
  status: PROMOTION_STATUS,
  expiryDate?: number
  err: string
}

export type SetPromotionAction = {
  type: typeof SET_PROMOTION,
  payload: Partial<IPromotion>
}

export type SetPromotionEffect = {
  type: typeof SET_PROMOTION_EFFECT,
  payload: {
    packages: PackageWithPromotion[],
    chosenPackage: PackageWithPromotion | null,
    promotion: IPromotion
  }
}

export interface FilteredPackage {
  isGreyOut?: boolean
}

export interface PackageWithPromotion extends Package.AsObject, FilteredPackage {
  isPromotionApplied?: boolean,
  promotionDiscountValue?: number,
  promoFinalPrice?: number
  expiryDate?: number
}

export interface SetPartialStateAction {
  type: typeof SET_PARTIAL_STATE,
  payload: Partial<AppState>
}

export interface SetPaymentOrderId {
  type: typeof SET_PAYMENT_ORDER_ID,
  payload: number
}

// export interface SetPaymentUrl {
//   type: typeof SET_PAYMENT_URL,
//   payload: string
// }
export interface SetOrderWaitingPayment {
  type: typeof SET_ORDER_WAITING_PAYMENT,
  payload: Order.AsObject
}


export type AppActions =
  SetLoadingAction |
  SetTokenAction |
  SetPlanIdAction |
  SetPlansAction |
  SetPackagesAction |
  SetMessageAction |
  SetUserAction |
  SetChosenPackageAction |
  SetSummaryAction |
  SetActiveOrderAction |
  SetOrdersAction |
  SetInitialDataAction |
  SetPromotionAction |
  SetPromotionEffect |
  SetPartialStateAction |
  SetPaymentOrderId |
  // SetPaymentUrl |
  SetOrderWaitingPayment
